import React, { useLayoutEffect, useRef } from 'react';
import { useState, useEffect } from 'react';
import { useAuth } from 'hooks';
import { VerificationMode } from '../secure-your-account/SecureYourAccount';
import { useNavigate } from 'react-router-dom';
import { Form,Input, Spin } from 'antd';
import {
  LoadingOutlined
} from '@ant-design/icons';
import { CFCDN } from 'modules/shop-front/shop-front-component/ProductCollection';
import smallLogo from 'assets/images/allin1logoNoText.png';
import { useAuthModalStore } from 'modules/zustand/store';
import { showNotification } from 'services/NotificationService';


interface SMSForm {
  setDefault: boolean;
}

const VerificationBySmsModal = () => {
  const { sendSecureSMS, loginSecure } = useAuth();

  const [smsCode, setSmsCode] = useState(new Array(6).fill(''));
  const [phone] = useState<string>(localStorage.getItem('phone') || '');
  const [messageErr, setMessageErr] = useState<string>();
  const [form] = Form.useForm<SMSForm>();
  const navigate = useNavigate();
  const [hiddenCheckBox, setHiddenCheckBox] = useState(true);
  const [checkDefault, setCheckDefault] = useState(false);
  const [pageLoading, setPageLoading ] = useState<boolean>(false);
  useEffect(() => {
    sendSecureSMS();
  }, []);

  useLayoutEffect(() => {
    const getRememberUser = async () => {
      try {
        const setDefault = await localStorage.getItem('setDefault');
        if (setDefault && setDefault == 'sms') {
          form.setFieldsValue({ setDefault: true });
          setHiddenCheckBox(false);
        } else if (setDefault && setDefault == 'totp')
          form.setFieldsValue({ setDefault: false });
      } catch (error) {
        //Err
      }
    };
    getRememberUser();
  }, []);

  const onResendSms = () => {
    sendSecureSMS();
    setSmsCode(new Array(6).fill(''));
  };



  const onChangeCode = (target: string) =>{
    const code = target
    if (code.length === 6) {
          onVerificationSmsCode(code);
        }
  }

  const setOffSecureModal = useAuthModalStore((state) => state.setOffSecureModal)
  const setOnLoginModal = useAuthModalStore((state) => state.setOnLoginModal)

  const onVerificationSmsCode = (val: string) => {
    const otpCode = val;
    const otpType = 'SMS';
    const setDefault = checkDefault;
    setPageLoading(true)
    loginSecure(otpCode, otpType, setDefault)
      .then(() => {
        setPageLoading(false)
        setOffSecureModal();
        showNotification('', 'Login successful! Welcome to All-in-1!');
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((e: { error_code: string; error_message: string }) => {
        setSmsCode(new Array(6).fill(''));
        if (e.error_code === 'OTP_CODE_INVALID') {
          setMessageErr(e.error_message);
        } else {
          setMessageErr(undefined);
        }
        setPageLoading(false)
      });
  };

 

  const validKeyForPayment = [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "Backspace",
  ];

  return (
    <div className=" flex flex-col justify-center items-center my-2 gap-3">
  
      <img style={{maxHeight:'70px'}} src={smallLogo}  />
      <h2>
      Two-factor authentication
      </h2>
      {messageErr && (
        <div className="flex justify-center items-center bg-[#FFE0E0] h-[40px] mb-5">
          {messageErr}
        </div>
      )}
      <div className="font-normal text-black text-sm !w-[300px]">
        Protecting your account is our top priority. Please confirm your account
        by entering the authrozation code sent to{' '}
        <span className="text-blue-600">{phone}</span>
      </div>
      
        <Input
          maxLength={6}
          onChange={(e) => onChangeCode(e.target.value)}
          onKeyPress={(event) => {
            if (!/[0-9]/.test(event.key)) {
                event.preventDefault();
            }
          }}
          className='!w-[300px] h-[40px] !rounded-md pr-3 py-1'
          
        >
        </Input>
        
      <div className="text-black text-sm mx-auto ">
        <p className="font-normal !w-[300px]">
          It may take a minute to receive your code. Haven’t received it?
          <span
            className="font-bold underline hover:cursor-pointer"
            onClick={onResendSms}
          >
            Resend a new code.
          </span>
        </p>
      </div>
      <LoadingOutlined  spin  className={`${pageLoading? '':'hidden'} text-xl`}/>
          
        <button
            onClick={() => {setOffSecureModal();setOnLoginModal()}}
            className={` w-full flex justify-center items-center shadow mt-3 border-none text-black bg-neutral-200 hover:bg-neutral-300 hover:shadow-md font-medium rounded-lg text-xl px-5 py-2 text-center inline-flex items-center  mb-2 hover:-translate-y-1 transition-all duration-300`}
            
            >
                Back to Login
        </button>
     

    </div>
 
  );
};

export default VerificationBySmsModal;
